import React, { PureComponent } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link
} from "react-router-dom";
import Button from "antd/lib/button";
import Spin from "antd/lib/spin";
import Words from "containers/Words";
import Lists from "containers/Lists";
import Login from "containers/Login";
import Games from "containers/Games";
import Public from "containers/Public";
import FixItalian from "containers/FixItalian";
import { auth } from "helpers/Firebase";

import "./style.css";

class App extends PureComponent {
  state = {
    user: null,
    isAuthStateRead: false
  };
  componentDidMount() {
    auth.onAuthStateChanged(user => {
      this.setState({
        user,
        isAuthStateRead: true
      });
    });
  }

  logout = () => {
    auth.signOut();
  };

  render() {
    const { user, isAuthStateRead } = this.state;

    return (
      <a href="https://words-editor.firebaseapp.com/">
        Go to https://words-editor.firebaseapp.com/
      </a>
    );

    if (!isAuthStateRead) {
      return (
        <div className="App__loading">
          <Spin tip="Loading..." />
        </div>
      );
    }

    return (
      <div>
        <Router>
          <div>
            {user && (
              <div
                style={{ position: "absolute", top: 10, right: 10, zIndex: 2 }}
              >
                <Link to="/games" style={{ margin: "0 10px" }}>
                  Games
                </Link>
                <Link to="/words">Words</Link>
                <Link to="/lists" style={{ margin: "0 10px" }}>
                  Lists
                </Link>
                <Button type="danger" onClick={this.logout}>
                  LOGOUT
                </Button>
              </div>
            )}
            <Route
              exact
              path="/public"
              render={props => {
                return <Public {...props} />;
              }}
            />
            <Route
              exact
              path="/italian-check"
              render={props => {
                return <FixItalian {...props} />;
              }}
            />
            <Route
              exact
              path="/"
              render={() => {
                if (user) {
                  return <Redirect to={{ pathname: "/words" }} />;
                }
                return <Login />;
              }}
            />
            <Route
              path="/lists"
              render={props => {
                if (!user && isAuthStateRead) {
                  return <Redirect to={{ pathname: "/" }} />;
                }
                return <Lists {...props} />;
              }}
            />
            <Route
              path="/words"
              render={props => {
                if (!user && isAuthStateRead) {
                  return <Redirect to={{ pathname: "/" }} />;
                }
                return <Words {...props} />;
              }}
            />
            <Route
              path="/games"
              render={props => {
                if (!user && isAuthStateRead) {
                  return <Redirect to={{ pathname: "/" }} />;
                }
                return <Games {...props} />;
              }}
            />
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js